import {MAP_DRAW_LAYERS, MAP_TOOLS} from '@src/constants/index.ts';
import {MapState, StateSlice, DrawTool} from '@src/stores/types.ts';
import {type Feature} from 'geojson';
import {type Coordinate} from 'ol/coordinate.js';
import {type Extent} from 'ol/extent';

const initialState = {
  fitExtent: [],
  locationMarkerCoordinate: null,
  /**
   * The current map extent/bounding box excluding ui paddings in EPSG:4326.
   */
  bufferedExtent: null,
  /**
   * The current map extent/bounding box in EPSG:4326.
   */
  extent: null,
  drawTool: {
    name: MAP_TOOLS.NONE,
    layer: MAP_DRAW_LAYERS.NONE,
    target: '',
  },
  /**
   * The current map feature AOI in EPSG:4326
   */
  feature: null,
  isOverZoomed: false,
  centerMarkerCoord: null,
};

export const setMapSlice: StateSlice<MapState> = set => ({
  ...initialState,
  setCenterMarkerCoord: (coordinate: Coordinate | null) =>
    set(
      state => {
        state.map.centerMarkerCoord = coordinate;
      },
      undefined,
      'map/setCenterMarkerCoord',
    ),
  setDrawTool: (tool: DrawTool) =>
    set(
      state => {
        state.map.drawTool = tool;
      },
      undefined,
      'map/setDrawTool',
    ),
  setIsOverZoomed: (isOverZoomed: boolean) =>
    set(
      state => {
        state.map.isOverZoomed = isOverZoomed;
      },
      undefined,
      'map/setIsOverzoomed',
    ),
  setLocationMarkerCoordinate: (coordinate: Coordinate) =>
    set(
      state => {
        state.map.locationMarkerCoordinate = coordinate;
      },
      undefined,
      'map/setLocationMarkerCoordinate',
    ),
  setMapBufferedExtent: (extent: Extent | null) =>
    set(
      state => {
        state.map.bufferedExtent = extent;
      },
      undefined,
      'map/setMapBufferedExtent',
    ),
  setMapExtent: (extent: Extent | null) =>
    set(
      state => {
        state.map.extent = extent;
      },
      undefined,
      'map/setMapExtent',
    ),
  setMapFeature: (feature: Feature | null) =>
    set(
      state => {
        state.map.feature = feature;
      },
      undefined,
      'map/setFeature',
    ),
  setMapFitExtent: (extent: Extent | null) =>
    set(
      state => {
        state.map.fitExtent = extent;
      },
      undefined,
      'map/setMapFitExtent',
    ),
});
